import React from 'react';

export default ({ participant }) => {
    let givenName = ""
    console.log(participant)
    if (participant && participant.name && participant.under_18) {
        givenName = participant.name.given_name.substring(0, 1);
    } else if (participant && participant.name ) {
        givenName = participant.name.given_name
    }

    const familyName = participant ? participant.name.family_name : '';
    const name = capitalize(givenName + ' ' + familyName);

    return <span>{name}</span>;
};

function capitalize(str) {
    return str.toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());
}
